import React, { useState, useEffect, useContext } from "react"
import { Box, Chip, CircularProgress } from '@mui/joy';
import { Text } from '../Typography';
import { Icon } from '../../assets';
import { useFormatter } from '../../utils';
import { useTranslation } from 'react-i18next';
import { useDataProvider } from '../../../mtska-frontend-data-provider';
import { Button } from "../Button";
import { AppContext } from "src/mtska-frontend-app-scaffolding";

import JSONPretty from 'react-json-pretty';
import { Bar } from ".";

const KPI = ({ title, dataProviderName, icon, filters, compareFilters = null, comparePositiveCondition = 'straight', format, className = '', filterbutton = {}, translate = true, compactformat = true, decimaldigits }) => {

    const { innerWidth } = useContext(AppContext)

    const { formatNumber, formatCurrency, formatPercentage } = useFormatter();
    const { t } = useTranslation();

    const { items, loadAll, reloadCounter } = useDataProvider(dataProviderName);
    const [score, setScore] = useState();
    const [compareScore, setCompareScore] = useState();
    const [timeline, setTimeline] = useState();
    const [knownFilters, setKnownFilters] = useState();
    const [delta, setDelta] = useState();

    useEffect(() => {
        const shouldReload = (JSON.stringify(filters) != knownFilters) || (typeof filters == typeof undefined && items.length == 0);

        if (shouldReload) {
            setKnownFilters(JSON.stringify(filters));
            loadAll(filters, null, null, null, compareFilters);
        }
    }, [reloadCounter, filters]);

    useEffect(() => {
        setScore(items.kpi);
        setCompareScore(items.compare);
        setTimeline(items.timeline ?? null);
    }, [items]);

    useEffect(() => {
        if (!score || !compareScore) {
            setDelta(null)
        } else {
            setDelta((score / compareScore) - 1);
        }
    }, [score, compareScore]);

    return (
        <Box className={"mtska-chart mtska-chart-kpi" + (className && ' ' + className) + (icon ? ' iconic' : '') + (timeline ? ' timelined' : '')}>
            {/* <JSONPretty data={filters} className="json-wrapper" style={{ overflow: 'scroll', fontSize: '10px' }}></JSONPretty> */}
            {icon &&
                <Box className="iconwrapper">
                    <Icon icon={icon} family="fal"></Icon>
                    {filterbutton?.visible && filters && (
                        <Box className='input-button-filter-wrapper'>
                            <Button
                                customSize={innerWidth > 600 ? 'sm' : 'xs'}
                                label={filterbutton?.label}
                                onClick={() => filterbutton.callback(filters)}
                                className="input-button-filter"
                            />
                        </Box>
                    )}
                </Box>
            }
            <Box className="scorewrapper">
                <Text level="title-sm" className="title">{translate ? t(title) : title}</Text>
                <Text level="title-lg" className="score">
                    {
                        (score == null) && <CircularProgress />
                    }

                    {
                        (score != null && !format) && formatNumber(score)
                    }

                    {
                        (score != null && format === 'currency') && formatCurrency(score, compactformat, decimaldigits)
                    }

                </Text>
                {
                    delta && (
                        <Chip
                            className={((comparePositiveCondition == 'straight' && delta >= 0) || (comparePositiveCondition == 'inverse' && delta <= 0)) ? "delta positive" : "delta negative"}
                            startDecorator={(delta >= 0) ? <Icon icon="faArrowUp" /> : <Icon icon="faArrowDown" />}
                        >
                            <span>{formatPercentage(delta, true)}</span>
                            <span className={"compare"}>
                                {
                                    (compareScore != null && !format) && formatNumber(compareScore)
                                }
                                {
                                    (compareScore != null && format === 'currency') && formatCurrency(compareScore, compactformat, decimaldigits)
                                }
                            </span>
                        </Chip>
                    )
                }
            </Box>

            {
                timeline && <Bar passedItems={timeline} width={80} height={70} variant={'micro'} format={format} showToolbar={false}/>
            }
        </Box>
    );
}

export default KPI;